module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"sub_title":"购物车商品列表"}}')
  delete Component.options._Ctor
}
